export const getReplaceThemeProps = <T extends object>(theme: T) => ({
    applyTheme: Object.fromEntries(
        Object.keys(theme).map((property) => [property, 'replace'])
    ) as { [property in keyof T]: 'replace' },
    theme,
});
